/**
 * MAO CustomerService
 */

export var MAO_CustomerService = (function () {
    return {
        init: function () {
            if ($('.js__customerservice').length > 0) {
                var url = window.location.href;
                var item = url.substr(url.indexOf('#'));
                if (url.indexOf('#') !== -1) {
                    $(item).collapse('show');
                }
            }

            $('.contact_js').on('click', null, function () {
                MAO_CustomerService.contact();
            });

            MAO_CustomerService.initVacaturesModal();
        },

        initVacaturesModal: function () {
            if (typeof route === 'undefined' || !route.contactModal) {
                return;
            }

            $(document).off('click.maoVacaturesModal', '.mao-button--vacatures');
            $(document).on('click.maoVacaturesModal', '.mao-button--vacatures', function (event) {
                event.preventDefault();
                MAO_CustomerService.openVacaturesModal();
            });

            $(document).off('submit.maoVacaturesModal', '.js-contact-modal-form');
            $(document).on('submit.maoVacaturesModal', '.js-contact-modal-form', function (event) {
                event.preventDefault();

                var form = $(this);
                MAO_CustomerService.submitVacaturesModalForm(form);
            });
        },

        getOrCreateVacaturesModal: function () {
            var modal = $('#customerserviceContactModal');

            if (modal.length > 0) {
                return modal;
            }

            $('body').append(
                '<div class="mao-modal modal fade" id="customerserviceContactModal" tabindex="-1" role="dialog" aria-hidden="true">' +
                    '<div class="modal-dialog" role="document">' +
                        '<div class="modal-content js-customerservice-contact-modal-content">' +
                            '<div class="modal-body">Bezig met laden...</div>' +
                        '</div>' +
                    '</div>' +
                '</div>'
            );

            return $('#customerserviceContactModal');
        },

        openVacaturesModal: function () {
            var modal = MAO_CustomerService.getOrCreateVacaturesModal();
            var modalContent = modal.find('.js-customerservice-contact-modal-content');

            modalContent.html('<div class="modal-body">Bezig met laden...</div>');
            modal.modal('show');

            $.get(route.contactModal)
                .done(function (html) {
                    modalContent.html(html);
                })
                .fail(function () {
                    modalContent.html('<div class="modal-body"><div class="alert alert-danger">Het formulier kon niet geladen worden. Probeer het opnieuw.</div></div>');
                });
        },

        submitVacaturesModalForm: function (form) {
            var notification = form.closest('.modal-body').find('.js-contact-modal-notification');
            var formData = new FormData(form[0]);

            notification.empty();
            form.find('.form-group').removeClass('has-error');
            form.find('.help-block').remove();

            $.ajax({
                type: 'POST',
                url: form.attr('action'),
                data: formData,
                dataType: 'json',
                processData: false,
                contentType: false,
            }).done(function (response) {
                var message = response.messages && response.messages[0]
                    ? response.messages[0]
                    : 'Bericht is verstuurd.';

                notification.html('<div class="alert alert-success">' + message + '</div>');
                form[0].reset();
            }).fail(function (xhr) {
                if (xhr.status === 422 && xhr.responseJSON && xhr.responseJSON.messages) {
                    $.each(xhr.responseJSON.messages, function (fieldName, messages) {
                        var field = form.find('[data-fieldname="' + fieldName + '"]');
                        field.addClass('has-error');

                        if (messages[0]) {
                            field.append('<span class="help-block">' + messages[0] + '</span>');
                        }
                    });

                    return;
                }

                var message = xhr.responseJSON && xhr.responseJSON.messages && xhr.responseJSON.messages[0]
                    ? xhr.responseJSON.messages[0]
                    : 'Er ging iets mis bij het versturen. Probeer het later opnieuw.';

                notification.html('<div class="alert alert-danger">' + message + '</div>');
            });
        },

        contact: function () {
            $.ajax({
                type: 'POST',
                url: route.contact,
                data: $('.mao-contact-form').serialize(),
                dataType: 'json',

                // show form request validation failures (422)
                error: function (data) {
                    var messages = data.responseJSON;

                    if (jQuery.type(messages.messages) === 'object') {
                        messages = messages.messages;
                    }

                    //clear old errors
                    var field = $('[data-fieldname]');
                    field.removeClass('error');
                    field.find('.mao-form--label').removeClass('error');
                    field.find('#form-error').empty().removeClass('has-error');
                    field.find('.form-group').removeClass('has-error');
                    field.find('select.mao-select').removeClass('has-error');

                    if (jQuery.type(messages) === 'object' && Object.keys(messages).length > 0) {
                        $.each(messages, function (key, value) {
                            $("[data-fieldname='" + key + "'] .mao-form--label")
                                .first()
                                .addClass('error');
                            $("[data-fieldname='" + key + "']")
                                .find('#form-error')
                                .first()
                                //.html('<span>'+value+'</span>')
                                .addClass('has-error');
                            $("[data-fieldname='" + key + "']")
                                .find('.form-group')
                                .first()
                                .removeClass('has-success')
                                .addClass('has-error');
                            $("[data-fieldname='" + key + "']")
                                .find('select.mao-select')
                                .first()
                                .addClass('has-error');
                        });
                    }
                },

                // show http success message (200)
                success: function (data) {
                    //clear old errors
                    var field = $('[data-fieldname]');
                    field.removeClass('error');
                    field.find('.mao-form--label').removeClass('error').removeClass('has-success');
                    field.find('#form-error').empty().removeClass('has-error').removeClass('has-success');
                    field.find('.form-group').removeClass('has-error').removeClass('has-success');
                    field.find('select.mao-select').removeClass('has-error').removeClass('has-success');

                    field.find("[name='message']").val('');

                    var notification = $('.notification-contact');
                    notification.removeClass('mao-notification warn').addClass('mao-notification ticked info');
                    notification.html(data.messages[0]);
                },
            });
        },
    };
})();
